import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { UserContextLoadGuard } from 'app/core/guards/user-context-load.guard';
import { logger } from 'app/core/util/logger';
import { Observable, of } from 'rxjs';
import * as fromRoot from '../..';
import * as actions from './i18n.actions';
import { goAction } from '../../router/router.actions';
import { first, switchMap } from 'rxjs/operators';

/**
 * Guard to async load an order before following a route
 */
@Injectable({ providedIn: 'root' })
export class ResetI18nGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    logger.debug('In ResetI18nGuard');

    return this.store.pipe(
      first(),
      switchMap(root => {
        if (route.data.reset === 'all') {
          this.store.dispatch(new actions.LanguageResetServerAction());
        }
        if (route.data.reset === 'missing') {
          this.store.dispatch(new actions.LanguageSetMissingServerAction());
        }
        this.store.dispatch(goAction({ path: '/admin/i18n' }));
        return of(false);
      })
    );
  }

  getDependencies(): any {
    return [UserContextLoadGuard];
  }

  getDependencyRouteData(): any {}
}
